// extracted by mini-css-extract-plugin
export default {"cardShadow":"cardPanelView_cardShadow__KXH3q"};